import React, { useRef, useState, useEffect, useContext } from 'react';
import { string, shape } from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withHydrator } from '@thd-olt-component-react/hydrator';

import { makeApiRequest } from '../../utils/requestHelpers';
import { isEventBusCreated, hasValidPipData, isExperienceDataResolved } from '../../utils/helpers';
import useMVCSID from '../../hooks/useMVCSID';
import './SponsoredPipBanner.scss';

const SponsoredPipBannerComponent = (props) => {
  const [hasData, setHasData] = useState(false);
  const experienceContext = useContext(ExperienceContext);
  let { pageContext } = props;
  const browserId = useMVCSID();
  const schema = 'pip_sponsored';
  const schemaId = `${schema}__banner_${pageContext.data.treatment}`;
  const [fbtSkus, setFbtSkus] = useState([]);
  const ref = useRef(fbtSkus);
  const maxWidth = experienceContext.channel === 'desktop' ? '100%' : '450px';
  const { storeId, isLocalized } = useStore({
    varnish: true,
    online: true
  });

  experienceContext.useStoreId = storeId;

  useEffect(() => {
    ref.current = fbtSkus;
  }, [fbtSkus]);

  useEffect(() => {
    if (isEventBusCreated()) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('frequently-bought-together.ready', (data) => {
        if (data?.output?.products) {
          const skus = data.output.products
            .map((product) => product.itemId)
            .filter((sku) => sku !== pageContext.data.itemId)
            .sort();
          if (ref.current.length === 0) {
            setFbtSkus(skus);
          }
        }
      });
    }
  }, [pageContext.data.itemId]);

  useEffect(() => {
    const isResolvedContext = isExperienceDataResolved({ isLocalized, experienceContext });
    if (hasValidPipData(pageContext, fbtSkus) && isResolvedContext && browserId) {
      makeApiRequest({
        browserId,
        schema,
        schemaId,
        experienceContext,
        pageContext,
        setHasData,
        bannerType: 'middle',
        eventBusData: { fbtSkus }
      });
    } else {
      setHasData(false);
    }
  }, [fbtSkus, isLocalized, experienceContext.mounted, browserId]);

  return (
    <div data-component="SponsoredPipBanner" className="sponsored_pip_banner_container" style={{ maxWidth }}>
      {hasData && <div id={schemaId} data-testid="sponsored-pip-banner" className="sponsored_pip_banner" />}
    </div>
  );
};

const propTypes = {
  pageContext: shape({
    label: string,
    treatment: string,
    data: shape({
      itemId: Number
    })
  })
};

const defaultProps = {
  pageContext: {}
};

SponsoredPipBannerComponent.propTypes = propTypes;
SponsoredPipBannerComponent.defaultProps = defaultProps;

const HydratedSponsoredPipBanner = withHydrator({
  id: 'hydrated-sponsored-pip-banner',
  className: 'sponsored-pip-banner-hydrator',
  scrollBuffer: 100
}, SponsoredPipBannerComponent);

const DynamicSponsoredPipBanner = withDynamicComponent(HydratedSponsoredPipBanner);
const SponsoredPipBanner = withLayoutGroup({ name: 'sponsored-pip-banner' }, DynamicSponsoredPipBanner);

SponsoredPipBanner.propTypes = propTypes;
SponsoredPipBanner.defaultProps = defaultProps;

export { SponsoredPipBannerComponent, SponsoredPipBanner };
